import { Fancybox } from "@fancyapps/ui";
var CertificatesAccordionBlock = /** @class */ (function () {
    function CertificatesAccordionBlock(element) {
        this.accordionBlock = element;
        this.accordionItems = Array.from(this.accordionBlock.querySelectorAll('.certificates-accordion-item'));
        this.viewDocumentButtons = Array.from(this.accordionBlock.querySelectorAll('[data-accordion-view-document]'));
        this.body = document.querySelector('body');
        this.pageOverlay = document.querySelector('[data-page-overlay]');
        this.pageLoader = document.querySelector('[data-page-loader]');
        this.addEventListeners();
    }
    CertificatesAccordionBlock.prototype.addEventListeners = function () {
        var _this = this;
        this.accordionItems.forEach(function (accordionItem) {
            var accordionItemHeader = accordionItem.querySelector('.certificates-accordion-item-header');
            accordionItemHeader.addEventListener('click', _this.toggleAccordionItem.bind(_this));
        });
        this.viewDocumentButtons.forEach(function (viewDocumentButton) {
            viewDocumentButton.addEventListener('click', _this.viewDocument.bind(_this));
        });
    };
    CertificatesAccordionBlock.prototype.toggleAccordionItem = function (event) {
        var currentItem = event.currentTarget;
        var accordionItem = currentItem.parentElement;
        var accordionContentIsOpen = accordionItem.classList.contains('active');
        if (accordionContentIsOpen) {
            accordionItem.classList.remove('active');
        }
        else {
            accordionItem.classList.add('active');
        }
    };
    CertificatesAccordionBlock.prototype.viewDocument = function (event) {
        var _this = this;
        var currentTarget = event.currentTarget;
        var documentSrc = currentTarget.dataset.accordionViewDocument;
        if (documentSrc) {
            // Check if document source is set
            this.body.classList.add('no-scroll');
            this.pageOverlay.classList.add('visible');
            this.pageLoader.classList.add('active');
            var fancybox = new Fancybox([
                {
                    src: documentSrc,
                    type: "pdf"
                },
            ]);
            fancybox.on('done', function (fancybox) {
                _this.body.classList.remove('no-scroll');
                _this.pageOverlay.classList.remove('visible');
                _this.pageLoader.classList.remove('active');
            });
        }
    };
    return CertificatesAccordionBlock;
}());
var certificatesAccordionBlocks = document.querySelectorAll('[data-certificates-accordion-block]');
certificatesAccordionBlocks.forEach(function (accordionBlock) {
    new CertificatesAccordionBlock(accordionBlock);
});
